import { componentRef } from './consts';

export default function (editor, opts = {}) {
  const options = opts;
  const bm = editor.BlockManager;
  const pfx = options.pfx;
  if (options.blocks.indexOf(componentRef) >= 0) {
    bm.add(componentRef, {
      label: `
      <svg fill="#000000" width="32" height="50" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <g id="OTP">
            <path d="M458.4741,112H265V62.41A31.3815,31.3815,0,0,0,233.5879,31H62.4077A31.3806,31.3806,0,0,0,31,62.41V449.59A31.4379,31.4379,0,0,0,62.4077,481h171.18A31.4388,31.4388,0,0,0,265,449.59V292H458.4771A22.5231,22.5231,0,0,0,481,269.4771V134.5259A22.5257,22.5257,0,0,0,458.4741,112ZM125.5,50.08h45a11.25,11.25,0,0,1,0,22.5h-45a11.25,11.25,0,0,1,0-22.5Zm44.9956,411.7651h-45a11.25,11.25,0,1,1,0-22.5h45a11.25,11.25,0,0,1,0,22.5ZM245.1982,420.25H50.7974V91.75H245.1982V112H125.3149A22.3149,22.3149,0,0,0,103,134.3149V269.6641A22.3357,22.3357,0,0,0,125.3359,292H166v36.1489a11.1221,11.1221,0,0,0,18.9868,7.8643L229,292h16.1982Zm-24.39-210.06a11.3086,11.3086,0,0,1,4.14,15.39,11.198,11.198,0,0,1-15.39,4.14L195.25,221.44V238a11.25,11.25,0,0,1-22.5,0V221.44L158.437,229.72a11.198,11.198,0,0,1-15.39-4.14,11.3164,11.3164,0,0,1,4.14-15.39L161.5,202l-14.313-8.28a11.2689,11.2689,0,0,1,11.25-19.5293L172.75,182.47V166a11.25,11.25,0,0,1,22.5,0v16.47l14.3086-8.2793a11.2689,11.2689,0,0,1,11.25,19.5293L206.5,202Zm108,0a11.3086,11.3086,0,0,1,4.14,15.39,11.198,11.198,0,0,1-15.39,4.14L303.25,221.44V238a11.25,11.25,0,0,1-22.5,0V221.44L266.437,229.72a11.198,11.198,0,0,1-15.39-4.14,11.3164,11.3164,0,0,1,4.14-15.39L269.5,202l-14.313-8.28a11.2689,11.2689,0,0,1,11.25-19.5293L280.75,182.47V166a11.25,11.25,0,0,1,22.5,0v16.47l14.3086-8.2793a11.2689,11.2689,0,0,1,11.25,19.5293L314.5,202Zm108,0a11.3086,11.3086,0,0,1,4.14,15.39,11.198,11.198,0,0,1-15.39,4.14L411.25,221.44V238a11.25,11.25,0,0,1-22.5,0V221.44L374.437,229.72a11.198,11.198,0,0,1-15.39-4.14,11.3164,11.3164,0,0,1,4.14-15.39L377.5,202l-14.313-8.28a11.2689,11.2689,0,0,1,11.25-19.5293L388.75,182.47V166a11.25,11.25,0,0,1,22.5,0v16.47l14.3086-8.2793a11.2689,11.2689,0,0,1,11.25,19.5293L422.5,202Z"/>
        </g>
      </svg>
      <div class="gjs-block-label">${options.labelTable}</div>
      `,
      category: options.labelOTPAuthenticatorCategory,
      content: `
                <form class="dc-form-default dc-form-bordered" data-gjs-type=${pfx}>
                    <div class="col-12 col-md-12">
                    <h4 class="title">OTP Authenticator</h4>
                    </div>
                    <div class="form-container row mx-auto" 
                        draggable="false" 
                        data-gjs-copyable="false" 
                        data-gjs-selectable="true" 
                        data-gjs-custom-name="Form Container">
                    <div class="alert alert-danger alert-message" style="display: none"></div>
                    <div class="alert alert-success success-message" style="display: none"></div>
                    <div class="form-group col-12 col-md-12" hidden>
                        <label>Email OTP Token</label>
                        <input name="emailOtpToken" 
                            type="text" 
                            placeholder="Enter your email otp token" 
                            class="form-control input--style"
                            data-form-element-query-params="emailOtpToken"
                            disabled />
                    </div>
                    <div class="form-group col-12 col-md-12" hidden>
                        <label>SMS OTP Token</label>
                        <input name="smsOtpToken" 
                            type="text" 
                            placeholder="Enter your email otp token" 
                            class="form-control input--style"
                            data-form-element-query-params="smsOtpToken"
                            disabled />
                    </div>
                    <div class="form-group col-12 col-md-12">
                        <label>OTP</label>
                        <input name="otp" 
                            type="text" 
                            placeholder="Enter OTP" 
                            class="form-control input--style" />
                    </div>
                    <div class="form-group col-12 col-md-12 p-t-10 no-border-bottom">
                        <button type="submit" class="btn btn-primary">Submit</button>
                    </div>
                    </div>
                </form>
`,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
          ${model.get('label')}
        </div>
      `,
    });
  }
}
